module.exports = __webpack_public_path__ + "img/stage_en.a35a85f.jpg";